import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useRouteMatch } from 'react-router-dom';
import { useQuery, useMutation } from '@apollo/client';

import {  useHistory } from 'react-router-dom';
import 'moment/locale/es';

const moment = require('moment-timezone').tz.setDefault('America/Mexico_City')
moment.locale('es');

//Components
import StyledPageContent from '../components/StyledPage';
import Loading from '../components/Loading';
import FormErrors,{ trowError } from '../components/FormErrors';

import titleSociosImage from '../assets/cupons/titulo-socios.jpg';
import bgFrame from '../assets/cupons/frame.jpg';

import AcreditacionProfile from '../models/AcreditacionProfile';
import {LIST_PROMOTION_AND_DISCOUNT_CUPONS} from '../models/PromotionAndDiscountCupons';



const StyledPage = styled(StyledPageContent)`
     padding: 0px;
     text-align: center;

     .listCupons{
          display: flex;
          flex-direction: column;
          align-items: center; 
          list-style: none;
          padding: 20px;
          gap: 20px;

          li{
               padding: 15px;
               width: 100%;
               max-width: 555px;

               height: 275px;
               aspect-ratio: 600 / 275;
               gap: 10px;

               background:#fff url(${bgFrame}) no-repeat 50% 100%;  
               border:solid 2px  #282e60;     
               display: grid;
               grid-template-columns: 120px auto;
               grid-template-rows: 55px auto 50px;

               grid-template-areas: "image title" "image text" "none vigencia";

               @media (max-width: 450px) {
                    grid-template-areas: "image" "title" "text" "vigencia";
                    grid-template-columns: auto;
                    grid-template-rows:auto;
                    height: auto;
                    aspect-ratio: auto;                      
               }

               h2{
                    color:var(--color-primary);
                    font-size: 30px;
                    font-weight: 500;
                    grid-template-columns: title;
                    text-align: center;
               }
               .image{
                    grid-area:image;
                    align-self: center; 
                    text-align:center;           
               }
               .alt{
                    grid-area:text;
                    text-align: center;
               }
               .vigencia{
                    grid-area:vigencia;
                    color:var(--color-rojo);
                    text-align: center;
               }

               p{
                    color:var(--color-primary);
                    
               }
                img{max-width:100%}
          }          
     }

`

export default  () => {
    let history = useHistory();
    let UserInfo=AcreditacionProfile.getProfile();

    const { loading, error, data } = useQuery(LIST_PROMOTION_AND_DISCOUNT_CUPONS,{
        variables:{
            'first':50,
            'page':0,
            'profile_uuid':UserInfo.uuid,  
            'type':'GAME_DAY_PROMO'
        },
        context:{
               //clientName:'SITE'
        }
    });

    if(loading)
        return <Loading />


    return (
        <StyledPage>
            {error?<div className="error-message"><FormErrors errors={error} /></div>:null}
               <img src={titleSociosImage} />

          <ol className='listCupons'>
               {data?.listPromotionAndDiscountCupons?.edge?.map( item => (
               <li>
                    <div className='image'><img src={item.image_url} /></div>
                    <h2>{item.title}</h2>
                    <p className='alt'>{item.alt}</p>
                    <p className='vigencia'>{item.valid_to}</p>
               </li>
               ))}
          </ol>
        </StyledPage>
    )
}

